import { Row, Col } from 'antd'
import React, { useContext } from 'react'
import { ThemeContext } from '../../theme/theme'

interface ShowBoxProps {
  type: string
  processDetail: any
}

export const ShowBox: React.FC<ShowBoxProps> = ({ type, processDetail }) => {
  const theme = useContext(ThemeContext)

  const labelStyle = {
    flex: '8rem',
    style: {
      color: theme.tc3,
      fontSize: '1rem',
      textAlign: 'right',
      marginBottom: 8,
    } as React.CSSProperties,
  }

  const valueStyles = {
    style: {
      color: theme.tc1,
      fontSize: '1rem',
      marginBottom: 4,
    } as React.CSSProperties,
  }

  console.log(processDetail?.handleDesc, 'processDetail')

  return (
    <>
      {type == 'DiscoverVo' && (
        <div>
          <Row gutter={20}>
            <Col span={24}>
              <Row>
                <h3>风险发现</h3>
              </Row>
              {processDetail?.handleDesc && (
                <Row wrap={false}>
                  <Col {...labelStyle}>处置流描述：</Col>
                  <Col {...valueStyles}>{processDetail?.handleDesc}</Col>
                </Row>
              )}
            </Col>
          </Row>
          {processDetail?.cautionContent && (
            <Row gutter={20}>
              <Col span={24}>
                <Row wrap={false}>
                  <Col {...labelStyle}>风险描述：</Col>
                  <Col {...valueStyles}>{processDetail?.cautionContent}</Col>
                </Row>
              </Col>
            </Row>
          )}
          {processDetail?.cautionLevel && (
            <Row gutter={20}>
              <Col span={24}>
                <Row wrap={false}>
                  <Col {...labelStyle}>风险等级：</Col>
                  <Col {...valueStyles}>{processDetail?.cautionLevel}</Col>
                </Row>
              </Col>
            </Row>
          )}
        </div>
      )}
      {type == 'AcceptVo' && (
        <div>
          <Row gutter={20}>
            <Col span={24}>
              <Row>
                <h3>风险接收</h3>
              </Row>
              {processDetail?.dutyDept && (
                <Row wrap={false}>
                  <Col {...labelStyle}>责任部门：</Col>
                  <Col {...valueStyles}>{processDetail?.dutyDept}</Col>
                </Row>
              )}
              {processDetail?.cautionOrigin && (
                <Row wrap={false}>
                  <Col {...labelStyle}>风险来源系统：</Col>
                  <Col {...valueStyles}>{processDetail?.cautionOrigin}</Col>
                </Row>
              )}
            </Col>
          </Row>
        </div>
      )}
      {type == 'NoNeedVo' && (
        <div>
          <Row gutter={20}>
            <Col span={24}>
              <Row>
                <h3>无需处置</h3>
              </Row>
              {processDetail?.handleDept && (
                <Row wrap={false}>
                  <Col {...labelStyle}>处置部门：</Col>
                  <Col {...valueStyles}>{processDetail?.handleDept}</Col>
                </Row>
              )}
              {processDetail?.handlePerson && (
                <Row wrap={false}>
                  <Col {...labelStyle}>处置人：</Col>
                  <Col {...valueStyles}>{processDetail?.handlePerson}</Col>
                </Row>
              )}
              {processDetail?.reasonDesc && (
                <Row wrap={false}>
                  <Col {...labelStyle}>原因描述：</Col>
                  <Col {...valueStyles}>{processDetail?.reasonDesc}</Col>
                </Row>
              )}
            </Col>
          </Row>
        </div>
      )}
      {type == 'CreateCheckVo' && (
        <div>
          <Row gutter={20}>
            <Col span={24}>
              <Row>
                <h3>创建检查任务</h3>
              </Row>
              {processDetail?.checkType && (
                <Row wrap={false}>
                  <Col {...labelStyle}>核查方式：</Col>
                  <Col {...valueStyles}>{processDetail?.checkType}</Col>
                </Row>
              )}
              {processDetail?.checkPerson && (
                <Row wrap={false}>
                  <Col {...labelStyle}>核查人员：</Col>
                  <Col {...valueStyles}>{processDetail?.checkPerson}</Col>
                </Row>
              )}
              {processDetail?.checkDept && (
                <Row wrap={false}>
                  <Col {...labelStyle}>核查部门：</Col>
                  <Col {...valueStyles}>{processDetail?.checkDept}</Col>
                </Row>
              )}
              {processDetail?.handleDept && (
                <Row wrap={false}>
                  <Col {...labelStyle}>处置部门：</Col>
                  <Col {...valueStyles}>{processDetail?.handleDept}</Col>
                </Row>
              )}
              {processDetail?.handlePerson && (
                <Row wrap={false}>
                  <Col {...labelStyle}>处置人员：</Col>
                  <Col {...valueStyles}>{processDetail?.handlePerson}</Col>
                </Row>
              )}
              {processDetail?.handleDesc && (
                <Row wrap={false}>
                  <Col {...labelStyle}>处置描述：</Col>
                  <Col {...valueStyles}>{processDetail?.handleDesc}</Col>
                </Row>
              )}
            </Col>
          </Row>
        </div>
      )}
      {type == 'DownVo' && (
        <div>
          <Row gutter={20}>
            <Col span={24}>
              <Row>
                <h3>风险下发</h3>
              </Row>
              {processDetail?.downDept && (
                <Row wrap={false}>
                  <Col {...labelStyle}>下发部门：</Col>
                  <Col {...valueStyles}>{processDetail?.downDept}</Col>
                </Row>
              )}
              {processDetail?.handlePerson && (
                <Row wrap={false}>
                  <Col {...labelStyle}>处置人员：</Col>
                  <Col {...valueStyles}>{processDetail?.handlePerson}</Col>
                </Row>
              )}
              {processDetail?.issueHandleDesc && (
                <Row wrap={false}>
                  <Col {...labelStyle}>处置描述：</Col>
                  <Col {...valueStyles}>{processDetail?.issueHandleDesc}</Col>
                </Row>
              )}
              {processDetail?.acceptDept && (
                <Row wrap={false}>
                  <Col {...labelStyle}>接收部门：</Col>
                  <Col {...valueStyles}>{processDetail?.acceptDept}</Col>
                </Row>
              )}
            </Col>
          </Row>
        </div>
      )}
      {type == 'UpVo' && (
        <div>
          <Row gutter={20}>
            <Col span={24}>
              <Row>
                <h3>转上级处置</h3>
              </Row>
              {processDetail?.handleDept && (
                <Row wrap={false}>
                  <Col {...labelStyle}>处置部门：</Col>
                  <Col {...valueStyles}>{processDetail?.handleDept}</Col>
                </Row>
              )}
              {processDetail?.handlePerson && (
                <Row wrap={false}>
                  <Col {...labelStyle}>处置人员：</Col>
                  <Col {...valueStyles}>{processDetail?.handlePerson}</Col>
                </Row>
              )}
              {processDetail?.handleDesc && (
                <Row wrap={false}>
                  <Col {...labelStyle}>处置描述：</Col>
                  <Col {...valueStyles}>{processDetail?.handleDesc}</Col>
                </Row>
              )}
            </Col>
          </Row>
        </div>
      )}
      {type == 'AuditVo' && (
        <div>
          <Row gutter={20}>
            <Col span={24}>
              <Row>
                <h3>审核</h3>
              </Row>
              {processDetail?.handleDept && (
                <Row wrap={false}>
                  <Col {...labelStyle}>处置部门：</Col>
                  <Col {...valueStyles}>{processDetail?.handleDept}</Col>
                </Row>
              )}
              {processDetail?.auditStatus && (
                <Row wrap={false}>
                  <Col {...labelStyle}>审核状态：</Col>
                  <Col {...valueStyles}>{processDetail?.auditStatus}</Col>
                </Row>
              )}
              {processDetail?.handlePerson && (
                <Row wrap={false}>
                  <Col {...labelStyle}>处置人员：</Col>
                  <Col {...valueStyles}>{processDetail?.handlePerson}</Col>
                </Row>
              )}
              {processDetail?.auditDesc && (
                <Row wrap={false}>
                  <Col {...labelStyle}>审核描述：</Col>
                  <Col {...valueStyles}>{processDetail?.auditDesc}</Col>
                </Row>
              )}
            </Col>
          </Row>
        </div>
      )}
      {type === 'DoneVo' && (
        <div>
          <Row gutter={20}>
            <Col span={24}>
              <Row>
                <h3>处置完成</h3>
              </Row>
              {processDetail?.checkPerson && (
                <Row wrap={false}>
                  <Col {...labelStyle}>检查人员：</Col>
                  <Col {...valueStyles}>{processDetail?.checkPerson}</Col>
                </Row>
              )}
              {processDetail?.checkContent && (
                <Row wrap={false}>
                  <Col {...labelStyle}>检查结果：</Col>
                  <Col {...valueStyles}>{processDetail?.checkContent}</Col>
                </Row>
              )}
              {processDetail?.auditDesc && (
                <Row wrap={false}>
                  <Col {...labelStyle}>检查内容：</Col>
                  <Col {...valueStyles}>{processDetail?.auditDesc}</Col>
                </Row>
              )}
              {processDetail?.checkDept && (
                <Row wrap={false}>
                  <Col {...labelStyle}>检查部门：</Col>
                  <Col {...valueStyles}>{processDetail?.checkDept}</Col>
                </Row>
              )}
              {processDetail?.handleDesc && (
                <Row wrap={false}>
                  <Col {...labelStyle}>处置描述：</Col>
                  <Col {...valueStyles}>{processDetail?.handleDesc}</Col>
                </Row>
              )}
            </Col>
          </Row>
        </div>
      )}
    </>
  )
}
